import { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import awardSvg1 from "../assets/awards/1.svg";
import awardSvg2 from "../assets/awards/2.svg";
import awardSvg3 from "../assets/awards/3.svg";
import awardSvg4 from "../assets/awards/4.svg";
import awardSvg5 from "../assets/awards/5.svg";
import awardSvg6 from "../assets/awards/6.svg";
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import Header from "../components/navbar/Header";
import { OurServices } from "../components/our-services";
import { Testimonials } from "../components/testimonials";
import { mobileOffersSliders } from '../json/index';
import { useEffect } from "react";
import awardSvg10 from "../assets/awards/10.svg";
import awardSvg11 from "../assets/awards/11.svg";
import awardSvg12 from "../assets/awards/12.svg";
import awardSvg13 from "../assets/awards/13.svg";
import awardSvg14 from "../assets/awards/14.svg";
import awardSvg8 from "../assets/awards/8.svg";
import awardSvg9 from "../assets/awards/9.svg";

import Achievements from "../components/Achievements";
import Channels from "../components/Channels";
import ProductOfMonth from "../components/ProductOfMonth";
const Home = () => {
  const [showAllAwards] = useState(false);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);



  const awards = [
    {
      img: awardSvg1,
      title: "Dealer within a region with maximum sales to service ratio",
    },
    { img: awardSvg2, title: "Highest number of MSD activations" },
    {
      img: awardSvg3,
      title:
        "Dealer within a region of maximum Sales Service ration (Annual Retails Category 7500 Vehicles)",
    },
    {
      img: awardSvg4,
      title:
        "Overall Performance in Service Workshop with Service Load between 500 and 1000",
    },
    { img: awardSvg5, title: " Highest MI Penetration" },
    { img: awardSvg6, title: "Highest AGS Sales -2" },
    { img: awardSvg8, title: "Highest Paid Corporate Training" },
    { img: awardSvg9, title: "Highest Workshop Conversion Ratio" },
    { img: awardSvg10, title: "Outstanding Sales Performance Q2" },
    { img: awardSvg11, title: "Best ISL initative-RO city" },
    { img: awardSvg12, title: "HIGHEST CORPORATE PENETRATION" },
    { img: awardSvg13, title: "Best Performance in Fleet-RO City" },
    { img: awardSvg14, title: "Highest Retail Growth Non RO City" },

    // JPEG images
    { img: require("../assets/awards/1.jpeg"), title: "Award Title 1" },
    { img: require("../assets/awards/2.jpeg"), title: "Award Title 2" },
    { img: require("../assets/awards/3.jpeg"), title: "Award Title 3" },
    { img: require("../assets/awards/4.jpeg"), title: "Award Title 4" },
    { img: require("../assets/awards/5.jpeg"), title: "Award Title 5" },
    { img: require("../assets/awards/6.jpeg"), title: "Award Title 6" },
    { img: require("../assets/awards/7.jpeg"), title: "Award Title 7" },
    { img: require("../assets/awards/8.jpeg"), title: "Award Title 8" },
    { img: require("../assets/awards/9.jpeg"), title: "Award Title 9" },
    { img: require("../assets/awards/10.jpeg"), title: "Award Title 10" },
    { img: require("../assets/awards/11.jpeg"), title: "Award Title 11" },
    { img: require("../assets/awards/12.jpeg"), title: "Award Title 12" },
    { img: require("../assets/awards/13.jpeg"), title: "Award Title 13" },
    { img: require("../assets/awards/14.jpeg"), title: "Award Title 14" },
  ];

  return (
    <div className="">
      <Helmet>
        <title>Maruti Suzuki Car Dealers in Hyderabad | Gem Maruti</title>
        <meta
          name="title"
          content="Maruti Suzuki Car Dealers in Hyderabad | Gem Maruti"
        />
        <meta
          name="description"
          content="Maruti Suzuki Car Dealers in Hyderabad. Gem Maruti is one of the top leading Maruti Car delaer in Hyderabad & Secunderabad. Visit now"
        />
      </Helmet>
      <Header />
      <div className="hidden mb-20 md:block">
        <Banner />
      </div>
      <div className="block md:hidden"><MobileSlider /></div>
      <div className="mx-auto space-y-24 ">
        <div className="px-5 mx-auto max-w-7xl">
          <Channels />
        </div>
        {/* our services  */}
        <div className="px-5 mx-auto max-w-7xl">
          <OurServices />
        </div>
        <div className="w-full mt-28">
          <Testimonials />
        </div>
        <div className="mx-auto max-w-7xl">
          {/* ACHIEVEMENTS */}
          <div className="relative my-10 group">
            <h3 className="text-lg font-medium text-center xl:text-3xl md:text-xl">
              Awards
            </h3>
            <div className="bg-red-600 h-1 lg:w-[100px] rounded-full w-20 mx-auto my-1"></div>

            <Swiper
              modules={[Navigation, Autoplay]}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              // navigation={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              spaceBetween={30}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
              className="my-10 "
            >
              {(showAllAwards ? awards : awards.slice(0, 8)).map(
                (award, index) => (
                  <SwiperSlide key={index} className="h-full">
                    <div
                      className="bg-[#F6F6F6] rounded-xl 
    hover:shadow-2xl transition-all duration-300
    p-6 text-center h-full flex flex-col mb-3"
                    >
                      <img
                        src={award.img}
                        alt={award.title}
                        className="w-full h-[220px] object-contain mx-auto hover:scale-125 hover:duration-1000 "
                      />

                      <div className="flex justify-center mt-4 mb-2">
                        <div className="w-12 h-[2px] bg-black"></div>
                      </div>

                      {/* FIXED HEIGHT TEXT */}
                      <div className="flex items-center justify-center h-[48px]">
                        <p className="text-[14px] font-medium text-gray-800 px-2 line-clamp-2">
                          {award.title}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ),
              )}
            </Swiper>
            {/* Navigation Buttons */}
            {/* CUSTOM NAVIGATION BUTTONS */}
            <div
              ref={prevRef}
              className="absolute z-20 p-3 text-white transition duration-300 -translate-y-1/2 rounded-full opacity-0 cursor-pointer top-1/2 left-2 bg-black/60 hover:bg-black group-hover:opacity-100"
            >
              ❮
            </div>

            <div
              ref={nextRef}
              className="absolute z-20 p-3 text-white transition duration-300 -translate-y-1/2 rounded-full opacity-0 cursor-pointer top-1/2 right-2 bg-black/60 hover:bg-black group-hover:opacity-100"
            >
              ❯
            </div>
          </div>
        </div>
        <ProductOfMonth />
        <div className="pb-20 mx-auto max-w-7xl">
          <Achievements />
        </div>
      </div>

      {/* <Range /> */}
      <Footer />
    </div>
  );
};

export default Home;


function MobileSlider() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{
          clickable: true,
        }}
        effect='fade'
        modules={[Autoplay, Pagination, EffectFade]}
        className='mySwiper sm:hidden'
      >
        {mobileOffersSliders.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={item.img}
              className='w-full max-w-full lg:mt-16'
              alt={item.alt}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}